"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/CircleSocialInstagram.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CircleSocialInstagram = function CircleSocialInstagram(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "circle-icon",
    viewBox: "0 0 515 515"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Instagram Circle Icon"), _react2.default.createElement("path", {
    d: "M257.5 215.76a41.74 41.74 0 1 0 41.74 41.74 41.79 41.79 0 0 0-41.74-41.74z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M359.11 202.15a46.31 46.31 0 0 0-46.26-46.26H202.14a46.31 46.31 0 0 0-46.26 46.26v110.7a46.31 46.31 0 0 0 46.26 46.26h110.7a46.31 46.31 0 0 0 46.26-46.26v-110.7zm-101.61 119a63.66 63.66 0 1 1 63.66-63.66 63.73 63.73 0 0 1-63.66 63.67zm77.7-118.5a16.09 16.09 0 1 1 4.71-11.37 16.23 16.23 0 0 1-4.71 11.37z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M257.5 0C115.29 0-.02 115.33-.02 257.5S115.27 515 257.48 515s257.5-115.28 257.5-257.5S399.71 0 257.5 0zm123.48 312.85a68.26 68.26 0 0 1-68.18 68.18H202.14a68.26 68.26 0 0 1-68.16-68.18v-110.7a68.26 68.26 0 0 1 68.18-68.18h110.7a68.26 68.26 0 0 1 68.12 68.18v110.7z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    },
    __self: undefined
  }));
};
exports.default = CircleSocialInstagram;